import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, unref as _unref, createVNode as _createVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = {
  key: 0,
  class: "error-message"
}
const _hoisted_6 = { class: "form-row row" }
const _hoisted_7 = { class: "form-field col-12 col-md-4" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "form-field col-12 col-md-4" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "form-field col-12 col-md-4" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-field" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "form-row row" }
const _hoisted_17 = { class: "form-field col-12 col-md-6" }
const _hoisted_18 = { class: "form-field col-12 col-md-6" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "form-row row" }
const _hoisted_22 = { class: "form-field col-12 col-md-4" }
const _hoisted_23 = {
  key: 0,
  disabled: ""
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "form-field col-12 col-md-8" }
const _hoisted_27 = { class: "section" }
const _hoisted_28 = {
  key: 0,
  class: "history-table"
}
const _hoisted_29 = {
  class: "col-main",
  "data-label": "Action"
}
const _hoisted_30 = { class: "row-meta" }
const _hoisted_31 = { class: "col-delete" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_34 = {
  key: 2,
  class: "add-row"
}
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "section" }
const _hoisted_37 = {
  key: 0,
  class: "attachments-grid"
}
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "attachment-desc" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = ["onChange"]
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "modal-footer" }
const _hoisted_46 = ["disabled"]

import { ref, computed } from 'vue'
import { jsPDF } from 'jspdf'
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import LookupDataService from '../services/LookupDataService'
import { convertImageToPngDataUrl } from '../utils/imageUtils'


export default /*@__PURE__*/_defineComponent({
  __name: 'EventFormModal',
  props: {
    baseUrl: {}
  },
  emits: ["close", "saved"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const emit = __emit

const isModalVisible = ref(false)
const readOnly = ref(false)
const errorMessage = ref('')
const isSaving = ref(false)
const isSavingAction = ref(false)
const isSavingAttachment = ref(false)

const eventId = ref<number>(0)
const eventDate = ref('')
const eventTime = ref('')
const eventTypeId = ref<number | null>(null)
const eventDetail = ref('')
const createdByOperatorName = ref('')
const eventCreatedDate = ref('')
const printClientName = ref('')
const printSiteName = ref('')
const printOfficerName = ref('')

const siteId = ref<number | null>(null)
const clientId = ref<number | null>(null)
const siteClients = ref<any[]>([])

const officerKind = ref<'employee' | 'subcontractor'>('employee')
const securityOfficerId = ref<number | null>(null)

const actions = ref<any[]>([])
const newActionText = ref('')
const newActionDateTime = ref('')
let nextTempKey = 0

const attachments = ref<any[]>([])
const pendingAttachments = ref<{ tempKey: number; file: File | null; description: string }[]>([
  { tempKey: 0, file: null, description: '' }
])

const eventTypes = ref<any[]>([])
const sites = ref<any[]>([])
const officers = ref<any[]>([])
const companies = ref<any[]>([])

const filteredOfficers = computed(() => {
  const contractorCompanyIds = new Set(
    companies.value.filter(c => c.isContractor).map(c => c.id)
  )
  const wantSubcontractor = officerKind.value === 'subcontractor'
  return officers.value.filter(o => {
    if (o.active === false) return false
    const isSubcontractorOfficer = o.securityCompanyId != null && contractorCompanyIds.has(o.securityCompanyId)
    return wantSubcontractor ? isSubcontractorOfficer : !isSubcontractorOfficer
  })
})

function officerDisplayLabel(o: any): string {
  if (officerKind.value !== 'subcontractor') return o.name
  const company = companies.value.find(c => c.id === o.securityCompanyId)
  return company ? `${company.name}: ${o.name}` : o.name
}

function authHeaders() {
  return { Authorization: `Bearer ${localStorage.token}`, 'Content-Type': 'application/json' }
}

function formatDateTime(value: string): string {
  if (!value) return 'N/A'
  try {
    return new Date(value).toLocaleString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
    })
  } catch {
    return value
  }
}

function loadLookupData() {
  const data = LookupDataService.getData()
  if (data) {
    eventTypes.value = data.eventTypes || []
    sites.value = data.sites || []
    officers.value = data.officers || []
    companies.value = data.companies || []
  }
}

function resetForm() {
  eventId.value = 0
  const now = new Date()
  eventDate.value = now.toISOString().slice(0, 10)
  eventTime.value = now.toTimeString().slice(0, 5)
  eventTypeId.value = eventTypes.value.length > 0 ? eventTypes.value[0].id : null
  eventDetail.value = ''
  createdByOperatorName.value = ''
  eventCreatedDate.value = ''
  printClientName.value = ''
  printSiteName.value = ''
  printOfficerName.value = ''
  siteId.value = null
  clientId.value = null
  siteClients.value = []
  officerKind.value = 'employee'
  securityOfficerId.value = null
  actions.value = []
  newActionText.value = ''
  newActionDateTime.value = ''
  attachments.value = []
  pendingAttachments.value = [{ tempKey: ++nextTempKey, file: null, description: '' }]
  errorMessage.value = ''
}

async function fetchSiteClients(id: number) {
  if (!id) {
    siteClients.value = []
    return
  }
  try {
    const res = await fetch(`${props.baseUrl}AppData/GetClientsForSelectedSite/${id}`, {
      method: 'GET',
      headers: authHeaders()
    })
    if (res.ok) {
      const data = await res.json()
      siteClients.value = data.clients || []
      if (siteClients.value.length === 1) {
        clientId.value = siteClients.value[0].id
      } else if (!siteClients.value.some((c: any) => c.id === clientId.value)) {
        clientId.value = null
      }
    }
  } catch (e) {
    console.error('Failed to load clients for site:', e)
  }
}

function onSiteChange(value: number | null) {
  fetchSiteClients(value ?? 0)
}

function openForAdd() {
  readOnly.value = false
  loadLookupData()
  resetForm()
  isModalVisible.value = true
  document.body.classList.add('modal-open')
}

function openForEdit(eventDto: any) {
  readOnly.value = false
  loadLookupData()
  resetForm()
  eventId.value = eventDto.id
  const dt = new Date(eventDto.eventDateTime)
  eventDate.value = dt.toISOString().slice(0, 10)
  eventTime.value = dt.toTimeString().slice(0, 5)
  eventTypeId.value = eventDto.eventTypeId
  eventDetail.value = eventDto.eventDetail || ''
  createdByOperatorName.value = eventDto.createdByOperatorName || ''
  eventCreatedDate.value = eventDto.createdDate || ''
  printClientName.value = eventDto.clientName || ''
  printSiteName.value = eventDto.siteName
    ? (eventDto.sitePostCode ? `${eventDto.siteName} (${eventDto.sitePostCode})` : eventDto.siteName)
    : ''
  printOfficerName.value = eventDto.securityOfficerName || ''

  if (eventDto.siteId) {
    siteId.value = eventDto.siteId
    clientId.value = eventDto.clientId
    fetchSiteClients(eventDto.siteId)
  }

  if (eventDto.securityOfficerId) {
    securityOfficerId.value = eventDto.securityOfficerId
    const officer = officers.value.find(o => o.id === eventDto.securityOfficerId)
    const contractorCompanyIds = new Set(companies.value.filter((c: any) => c.isContractor).map((c: any) => c.id))
    officerKind.value = officer && contractorCompanyIds.has(officer.securityCompanyId) ? 'subcontractor' : 'employee'
  }

  actions.value = eventDto.eventActions || []
  attachments.value = (eventDto.eventAttachments || []).map((a: any) => ({ ...a, iconUrl: null }))
  loadAttachmentIcons()

  isModalVisible.value = true
  document.body.classList.add('modal-open')
}

function openForView(eventDto: any) {
  openForEdit(eventDto)
  readOnly.value = true
}

async function loadAttachmentIcons() {
  for (const attachment of attachments.value) {
    try {
      const res = await fetch(`${props.baseUrl}Events/Attachments/${attachment.id}/Url?eventId=${eventId.value}`, {
        method: 'GET',
        headers: authHeaders()
      })
      if (res.ok) {
        const data = await res.json()
        attachment.iconUrl = data.url
      }
    } catch (e) {
      console.error('Failed to load attachment icon:', e)
    }
  }
}

function closeModal() {
  isModalVisible.value = false
  document.body.classList.remove('modal-open')
  emit('close')
}

function buildEventDateTime(): string {
  return `${eventDate.value}T${eventTime.value || '00:00'}:00`
}

async function saveEvent() {
  if (!eventTypeId.value) {
    errorMessage.value = 'Please select an event type.'
    return
  }

  errorMessage.value = ''
  isSaving.value = true
  const isNewEvent = !eventId.value
  try {
    const payload: any = {
      Id: eventId.value,
      EventDateTime: buildEventDateTime(),
      EventTypeId: eventTypeId.value,
      EventDetail: eventDetail.value,
      ClientId: siteId.value ? clientId.value : null,
      SiteId: siteId.value,
      SecurityOfficerId: securityOfficerId.value
    }

    if (isNewEvent) {
      const pendingActions = actions.value
        .filter(a => !a.id && a.actionTaken)
        .map(a => ({ ActionTaken: a.actionTaken, ActionDateTime: a.actionDateTime || null }))
      const unaddedText = newActionText.value.trim()
      if (unaddedText) {
        pendingActions.push({ ActionTaken: unaddedText, ActionDateTime: newActionDateTime.value || null })
      }
      payload.EventActions = pendingActions
    }

    const url = isNewEvent ? 'Events/Add' : 'Events/Update'
    const res = await fetch(props.baseUrl + url, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(payload)
    })
    const result = await res.json()

    if (res.ok && result.event) {
      eventId.value = result.event.id
      actions.value = result.event.eventActions || []
      attachments.value = (result.event.eventAttachments || []).map((a: any) => ({ ...a, iconUrl: null }))

      if (isNewEvent) {
        newActionText.value = ''
        newActionDateTime.value = ''
      } else if (newActionText.value.trim()) {
        await addActionRow()
      }

      await uploadPendingAttachments()

      loadAttachmentIcons()
      emit('saved')
    } else {
      errorMessage.value = result.responseMessage || 'Failed to save event.'
    }
  } catch (e) {
    console.error(e)
    errorMessage.value = 'Failed to save event.'
  } finally {
    isSaving.value = false
  }
}

async function addActionRow() {
  const text = newActionText.value.trim()
  if (!text) return

  if (!eventId.value) {
    actions.value.unshift({ tempKey: ++nextTempKey, actionTaken: text, actionDateTime: newActionDateTime.value || null })
    newActionText.value = ''
    newActionDateTime.value = ''
    return
  }

  isSavingAction.value = true
  try {
    const res = await fetch(props.baseUrl + 'Events/Actions/Add', {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({
        EventId: eventId.value,
        ActionTaken: text,
        ActionDateTime: newActionDateTime.value || null
      })
    })
    const result = await res.json()
    if (res.ok && result.eventAction) {
      actions.value.unshift(result.eventAction)
      newActionText.value = ''
      newActionDateTime.value = ''
      emit('saved')
    } else {
      errorMessage.value = result.responseMessage || 'Failed to add action.'
    }
  } catch (e) {
    console.error(e)
    errorMessage.value = 'Failed to add action.'
  } finally {
    isSavingAction.value = false
  }
}

async function deleteAction(action: any) {
  if (!action.id) return
  try {
    const res = await fetch(`${props.baseUrl}Events/Actions/${action.id}/Delete`, {
      method: 'POST',
      headers: authHeaders()
    })
    if (res.ok) {
      actions.value = actions.value.filter(a => a.id !== action.id)
      emit('saved')
    }
  } catch (e) {
    console.error('Failed to delete action:', e)
  }
}

function onPendingFileSelected(event: Event, slot: { tempKey: number; file: File | null; description: string }) {
  const target = event.target as HTMLInputElement
  slot.file = target.files && target.files.length > 0 ? target.files[0] : null
}

function addPendingAttachmentSlot() {
  const lastSlot = pendingAttachments.value[pendingAttachments.value.length - 1]
  if (!lastSlot || !lastSlot.file) return
  pendingAttachments.value.push({ tempKey: ++nextTempKey, file: null, description: '' })
}

async function uploadPendingAttachments() {
  const slotsToUpload = pendingAttachments.value.filter(s => s.file)
  if (slotsToUpload.length === 0) return

  isSavingAttachment.value = true
  try {
    for (const slot of slotsToUpload) {
      const formData = new FormData()
      formData.append('eventId', String(eventId.value))
      formData.append('file', slot.file as File)
      formData.append('description', slot.description)

      const res = await fetch(props.baseUrl + 'Events/Attachments/Upload', {
        method: 'POST',
        headers: { Authorization: `Bearer ${localStorage.token}` },
        body: formData
      })
      const result = await res.json()
      if (res.ok && result.eventAttachment) {
        attachments.value.push({ ...result.eventAttachment, iconUrl: result.iconUrl })
      } else {
        errorMessage.value = result.responseMessage || 'Failed to upload attachment.'
      }
    }
    pendingAttachments.value = [{ tempKey: ++nextTempKey, file: null, description: '' }]
  } catch (e) {
    console.error(e)
    errorMessage.value = 'Failed to upload attachment.'
  } finally {
    isSavingAttachment.value = false
  }
}

async function deleteAttachment(attachment: any) {
  try {
    const res = await fetch(`${props.baseUrl}Events/Attachments/${attachment.id}/Delete`, {
      method: 'POST',
      headers: authHeaders()
    })
    if (res.ok) {
      attachments.value = attachments.value.filter(a => a.id !== attachment.id)
      emit('saved')
    }
  } catch (e) {
    console.error('Failed to delete attachment:', e)
  }
}

function formatDatePrint(value: string): string {
  if (!value) return ''
  const d = new Date(value)
  if (isNaN(d.getTime())) return ''
  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0')
  return `${day}-${month}-${d.getFullYear()}`
}

async function printEventPdf() {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' })
  const pageWidth = doc.internal.pageSize.getWidth()
  const pageHeight = doc.internal.pageSize.getHeight()
  const marginX = 15

  const companyName = localStorage.getItem('companyNameForHeader') || ''
  const companyAddress = [
    localStorage.getItem('companyStreetAddress'),
    localStorage.getItem('companyTown'),
    localStorage.getItem('companyCity'),
    localStorage.getItem('companyPostCode')
  ].filter(Boolean).join(', ')
  // Pre-converted to PNG once at branding load (see App.vue) since jsPDF
  // can't embed the .ico favicon directly; only fall back to converting
  // here if that cache is missing (e.g. icon changed since last login).
  let logoDataUrl = localStorage.getItem('companyIconPng')
  if (!logoDataUrl) {
    const logoUrl = localStorage.getItem('companyIconFile')
    logoDataUrl = logoUrl ? await convertImageToPngDataUrl(logoUrl) : null
  }

  let headerTextX = marginX
  if (logoDataUrl) {
    try {
      doc.addImage(logoDataUrl, marginX, 10, 18, 18)
      headerTextX = marginX + 24
    } catch {
      headerTextX = marginX
    }
  }

  doc.setFont('helvetica', 'bold')
  doc.setFontSize(16)
  doc.text(companyName, headerTextX, 18)

  doc.setFont('helvetica', 'normal')
  doc.setFontSize(10)
  if (companyAddress) doc.text(companyAddress, headerTextX, 24)
  doc.text(`Date: ${formatDatePrint(new Date().toISOString())}`, pageWidth - marginX, 18, { align: 'right' })

  const boxWidth = 50
  doc.rect((pageWidth - boxWidth) / 2, 32, boxWidth, 9)
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(11)
  doc.text('EVENT REPORT', pageWidth / 2, 38, { align: 'center' })

  function printLabelValue(label: string, value: string, x: number, yy: number) {
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(10)
    doc.text(label, x, yy)
    doc.setFont('helvetica', 'normal')
    doc.text(value, x + doc.getTextWidth(label) + 2, yy)
  }

  const siteNameVal = printSiteName.value
  const clientNameVal = printClientName.value
  const officerNameVal = printOfficerName.value
  const eventTypeNameVal = eventTypes.value.find(t => t.id === eventTypeId.value)?.name || ''
  const officerLabel = officerKind.value === 'subcontractor' ? 'SUBCONTRACTOR NAME:' : 'EMPLOYEE NAME:'

  let y = 50
  printLabelValue('EVENT DATE:', formatDatePrint(eventDate.value), marginX, y)
  printLabelValue('EVENT TIME:', eventTime.value, marginX + 55, y)
  printLabelValue('EVENT REPORTING DATE:', formatDatePrint(eventCreatedDate.value) || formatDatePrint(new Date().toISOString()), marginX + 100, y)
  y += 7

  if (eventTypeNameVal) {
    printLabelValue('EVENT TYPE:', eventTypeNameVal, marginX, y)
    y += 7
  }

  if (clientNameVal) {
    printLabelValue('CLIENT NAME:', clientNameVal, marginX, y)
    y += 7
  }
  if (siteNameVal) {
    printLabelValue('SITE NAME:', siteNameVal, marginX, y)
    y += 7
  }
  if (officerNameVal) {
    printLabelValue(officerLabel, officerNameVal, marginX, y)
    y += 7
  }

  y += 6
  doc.setFont('helvetica', 'bold')
  doc.setFontSize(10)
  doc.text('EVENT DESCRIPTION:', marginX, y)
  y += 7

  doc.setFont('helvetica', 'normal')
  const descLines = doc.splitTextToSize(eventDetail.value || '', pageWidth - marginX * 2)
  doc.text(descLines, marginX, y)

  const footerY = pageHeight - 12
  const printedBy = localStorage.getItem('officerName') || localStorage.getItem('userName') || ''
  doc.setFont('helvetica', 'italic')
  doc.setFontSize(9)
  doc.text(`Printed By: ${printedBy}`, marginX, footerY)
  doc.text('Powered by Emerging Solution Ltd', pageWidth / 2, footerY, { align: 'center' })
  doc.text(`Created By: ${createdByOperatorName.value}`, pageWidth - marginX, footerY, { align: 'right' })

  doc.save(`Event_${eventId.value}.pdf`)
}

__expose({ openForAdd, openForEdit, openForView })

return (_ctx: any,_cache: any) => {
  return (isModalVisible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-backdrop",
          onClick: closeModal
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(readOnly.value ? 'View Event' : (eventId.value ? 'Edit Event' : 'Add Event')), 1),
            _createElementVNode("button", { onClick: closeModal }, "×")
          ]),
          _createElementVNode("div", _hoisted_4, [
            (errorMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errorMessage.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[11] || (_cache[11] = _createElementVNode("label", null, "Date", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((eventDate).value = $event)),
                  disabled: readOnly.value
                }, null, 8, _hoisted_8), [
                  [_vModelText, eventDate.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[12] || (_cache[12] = _createElementVNode("label", null, "Time", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((eventTime).value = $event)),
                  disabled: readOnly.value
                }, null, 8, _hoisted_10), [
                  [_vModelText, eventTime.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[13] || (_cache[13] = _createElementVNode("label", null, "Event Type", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((eventTypeId).value = $event)),
                  disabled: readOnly.value
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventTypes.value, (type) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: type.id,
                      value: type.id
                    }, _toDisplayString(type.name), 9, _hoisted_13))
                  }), 128))
                ], 8, _hoisted_12), [
                  [
                    _vModelSelect,
                    eventTypeId.value,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[14] || (_cache[14] = _createElementVNode("label", null, "Event Detail", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((eventDetail).value = $event)),
                rows: "3",
                disabled: readOnly.value
              }, null, 8, _hoisted_15), [
                [_vModelText, eventDetail.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[15] || (_cache[15] = _createElementVNode("label", null, "Site", -1)),
                _createVNode(_unref(Multiselect), {
                  modelValue: siteId.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((siteId).value = $event)),
                  options: sites.value.map(s => ({ value: s.id, label: s.name })),
                  placeholder: "Select site...",
                  searchable: true,
                  clearable: true,
                  disabled: readOnly.value,
                  onChange: onSiteChange
                }, null, 8, ["modelValue", "options", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[17] || (_cache[17] = _createElementVNode("label", null, "Client", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((clientId).value = $event)),
                  disabled: siteClients.value.length === 0 || readOnly.value
                }, [
                  _cache[16] || (_cache[16] = _createElementVNode("option", { value: null }, "-- Select client --", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(siteClients.value, (client) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: client.id,
                      value: client.id
                    }, _toDisplayString(client.name), 9, _hoisted_20))
                  }), 128))
                ], 8, _hoisted_19), [
                  [
                    _vModelSelect,
                    clientId.value,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[20] || (_cache[20] = _createElementVNode("label", null, "Officer Kind", -1)),
                (eventId.value)
                  ? (_openBlock(), _createElementBlock("select", _hoisted_23, [
                      _createElementVNode("option", null, _toDisplayString(officerKind.value === 'subcontractor' ? 'Subcontractor' : 'Employee'), 1)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          value: "employee",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((officerKind).value = $event)),
                          disabled: readOnly.value
                        }, null, 8, _hoisted_24), [
                          [_vModelRadio, officerKind.value]
                        ]),
                        _cache[18] || (_cache[18] = _createTextVNode(" Employee ", -1))
                      ]),
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          value: "subcontractor",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((officerKind).value = $event)),
                          disabled: readOnly.value
                        }, null, 8, _hoisted_25), [
                          [_vModelRadio, officerKind.value]
                        ]),
                        _cache[19] || (_cache[19] = _createTextVNode(" Subcontractor ", -1))
                      ])
                    ], 64))
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", null, _toDisplayString(officerKind.value === 'subcontractor' ? 'Subcontractors' : 'Employees'), 1),
                _createVNode(_unref(Multiselect), {
                  modelValue: securityOfficerId.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((securityOfficerId).value = $event)),
                  options: filteredOfficers.value.map(o => ({ value: o.id, label: officerDisplayLabel(o) })),
                  placeholder: "Select officer...",
                  searchable: true,
                  clearable: true,
                  disabled: readOnly.value
                }, null, 8, ["modelValue", "options", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[21] || (_cache[21] = _createElementVNode("h4", null, "Actions", -1)),
              (actions.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actions.value, (action) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: action.id ?? action.tempKey,
                        class: "table-row"
                      }, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, _toDisplayString(action.actionByOperatorName || 'Pending') + " — " + _toDisplayString(formatDateTime(action.actionDateTime || action.createdDate)), 1),
                          _createElementVNode("div", null, _toDisplayString(action.actionTaken), 1)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          (action.id && !readOnly.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn-remove",
                                onClick: ($event: any) => (deleteAction(action))
                              }, "x", 8, _hoisted_32))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_33, "No actions logged yet")),
              (!readOnly.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newActionText).value = $event)),
                      rows: "2",
                      placeholder: "Describe the action taken"
                    }, null, 512), [
                      [_vModelText, newActionText.value]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "datetime-local",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newActionDateTime).value = $event))
                    }, null, 512), [
                      [_vModelText, newActionDateTime.value]
                    ]),
                    _createElementVNode("button", {
                      class: "btn-add-inline",
                      disabled: !newActionText.value.trim() || isSavingAction.value,
                      onClick: addActionRow
                    }, "+", 8, _hoisted_35)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _cache[22] || (_cache[22] = _createElementVNode("h4", null, "Attachments", -1)),
              (attachments.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachments.value, (attachment) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: attachment.id,
                        class: "attachment-item"
                      }, [
                        (attachment.iconUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: attachment.iconUrl,
                              class: "attachment-thumb"
                            }, null, 8, _hoisted_38))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_39, _toDisplayString(attachment.description || attachment.blobFileName), 1),
                        (!readOnly.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn-remove",
                              onClick: ($event: any) => (deleteAttachment(attachment))
                            }, "x", 8, _hoisted_40))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_41, "No attachments yet")),
              (!readOnly.value)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(pendingAttachments.value, (slot, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: slot.tempKey,
                      class: "add-row"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((slot.description) = $event),
                        placeholder: "Description (optional)"
                      }, null, 8, _hoisted_42), [
                        [_vModelText, slot.description]
                      ]),
                      _createElementVNode("input", {
                        type: "file",
                        accept: "image/*",
                        onChange: ($event: any) => (onPendingFileSelected($event, slot))
                      }, null, 40, _hoisted_43),
                      (idx === pendingAttachments.value.length - 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn-add-inline",
                            disabled: !slot.file || isSavingAttachment.value,
                            onClick: addPendingAttachmentSlot
                          }, "+", 8, _hoisted_44))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            (!readOnly.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn-add",
                  disabled: isSaving.value,
                  onClick: saveEvent
                }, _toDisplayString(eventId.value ? 'UPDATE' : 'SAVE'), 9, _hoisted_46))
              : _createCommentVNode("", true),
            (eventId.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn-print",
                  onClick: printEventPdf
                }, "PRINT PDF"))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn-cancel",
              onClick: closeModal
            }, "CLOSE")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})